import { IRootState } from '../../../store'
import { IRulesState } from '../store/rules.types'

export const getRulesSelector = (state: IRootState): IRulesState => state.rules
